<template>
    <div class="box1">
        <div class="box_1">
            <van-collapse v-model="activeName" accordion>
                <van-collapse-item v-for="item in data" :key="item.id" :title="item.name" :name="item.id">
                    <p class="p_1" v-for="i in item.child" :key="i.id" @click="childBtn(item, i.id)">{{ i.title }}</p>

                </van-collapse-item>
            </van-collapse>
        </div>
        <div class="box_2">
            <p>© {{ new Date().getFullYear() }} Shine Optics Technology Company Limited</p>
            <!-- <p> <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">渝ICP备2022000344号-1</a></p> -->

        </div>
    </div>
</template>

<script>
import { reactive, toRefs, watch } from 'vue'
import { useRouter } from "vue-router";
export default {
    emits: ['submitData'],
    setup(props, { emit }) {
        const routes = useRouter();
        watch(() => routes.currentRoute.value.path, (count, prevCount) => {
            // console.log(count);
            if (count == '/ja/product') {
                localStorage.setItem('menuId', 1)
            } else if (count == '/ja/about'|| count == '/ja/manufacture' || count == '/ja/aboutId' || count == '/ja/aboutImg' || count == '/ja/quality' || count == '/ja/research') {
                localStorage.setItem('menuId', 2)
            } else if (count == '/ja/news' || count == '/ja/news') {
                localStorage.setItem('menuId', 3)
            } else if (count == '/ja/cooperation' || count == '/ja/business_partner' || count == '/ja/commercial_ethics' || count == '/ja/social_responsibility' || count == '/ja/develop') {
                localStorage.setItem('menuId', 4)
            } else if (count == '/ja/join' || count == '/ja/joinId' || count == '/ja/idea') {
                localStorage.setItem('menuId', 5)
            } else if (count == '/ja/contactus') {
                localStorage.setItem('menuId', 6)
            }
        }, { immediate: true })
        const route = useRouter();
        const state = reactive({
            activeName: 0,
            data:  [
        { id: 1, svg: require('@/assets/foot/产品中心.svg'), name: '製品情報', child: [{ id: 5, title: 'モバイル端末' }, { id: 4, title: 'ノートパソコン製品' }, { id: 3, title: 'アイオット' }, { id: 2, title: '車載と医療製品' },{id:1,title:"LED"}] },
        { id: 5, svg: require('@/assets/foot/加入盛泰.svg'), name: '採用情報', child: [{ id: 1, title: '求人情報' }, { id: 2, title: '人事理念' }] },
        { id: 3, svg: require('@/assets/foot/新闻活动.svg'), name: 'ニュースリリース', child: [{ id: 1, title: 'ニュース' }, { id: 2, title: 'イベント' }] },
        { id: 2, svg: require('@/assets/foot/盛泰制造.svg'), name: '事業案内', child: [{ id: 1, title: '技術開発' }, { id: 2, title: '品質保証' }, { id: 3, title: '生産環境' }] },
      ]
        })
        let methods = {
            childBtn(item, id) {
                // alert(id)
                // console.log(item);
                localStorage.setItem('menuId', item.id)
          switch (item.id) {
          case 1:
            route.push('/ja/product')
            localStorage.setItem('id', id)
            emit('submitData', id)
            break;
          case 2:
            console.log(item);
            if(id==3){
                  localStorage.setItem('emp_id', 1)
                  route.push({ path: '/ja/manufacture' })

            }else if(id==2){
                  route.push('/ja/quality')

            }else if(id==1){
              route.push('/ja/research')

            }
            break;
          case 3:
            route.push("/ja/news");
            break;
          case 4:
            break;
          case 5:
            if(id == 1){
                // console.log(22222);
                route.push('/ja/joinId')
            }else if(id==2){
              route.push('/ja/idea')
            }
            break;

          default:
        }
                // window.scrollTo(0, 0);

            }
        }
        return {
            ...toRefs(state),
            ...methods

        }
    }
}
</script>

<style scoped lang="less">
.box1 {
    width: 100%;
    height: auto;

    .box_1 {
        width: 100%;
        min-height: 1000px;
        background-color: #F2F2F2;
    }

    .box_2 {
        width: 100%;
        background-color: #E6E6E6;
        height: 300px;
        float: left;

        p:nth-child(1) {
            margin-top: 75px;
        }

        p {
            text-align: center;
            color: black;
            font-size: 40px;

            background-color: #E6E6E6;
            margin: 0;
            padding: 0;

            a {
                cursor: pointer;
                color: black;
                text-decoration: none;
            }
        }
    }
}

::v-deep .van-cell__title {
    font-size: 55px;
    font-weight: bold;
    line-height: 220px;
    height: 200px;
    border-bottom: 1px solid #ccc;
    box-sizing: border-box;
    margin-left: 30px;
}

.p_1 {
    margin: 80px 50px 0px;
    height: 100px;
    font-size: 45px;
    color: black;
    box-sizing: border-box;
    cursor: pointer;
    border-bottom: 1px solid #ccc;
    width: 90%;
}

.p_1:hover {
    color: red;
}

::v-deep .van-badge__wrapper {
    font-size: 80px !important;
    margin-top: 100px;
    margin-right: 60px;

}

::v-deep .van-collapse-item__content {
    background-color: #F2F2F2;
}

::v-deep .van-cell {
    background-color: #F2F2F2;
}
</style>